<app-dialog-heading [heading]="heading"></app-dialog-heading>

<form [formGroup]="formGroup">
  <div mat-dialog-content>

    <div class="clearfix ">
      <!-------------------------------------->
      <!-- Left Section-->
      <!-------------------------------------->
      <div class="md-col md-col-6">
        <ng-container [ngTemplateOutlet]="inputAndDropdownFields"></ng-container>
      </div>

      <!-------------------------------------->
      <!-- Right Section-->
      <!-------------------------------------->
      <div class="md-col md-col-6">
        <div class="flex flex-column">
          <div class="col-12">

            <!-- Assigned to -->
            <ng-container [ngTemplateOutlet]="LookupValuesTemplate"
                          [ngTemplateOutletContext]="{
                    label:'Assigned to',
                    items: usersLookUpValues,
                    required: true,
                    formControlInstance: assigneeFormControl
                   }">
            </ng-container>

            <!-- Reported By -->
            <ng-container [ngTemplateOutlet]="LookupValuesTemplate"
                          [ngTemplateOutletContext]="{
                   label:'Reported By',
                   items: usersLookUpValues,
                   required: true,
                   formControlInstance: reporterFormControl
                  }">
            </ng-container>

            <!-- Start Date -->
            <ng-container [ngTemplateOutlet]="datePickerTemplate"
                          [ngTemplateOutletContext]="{
                   label:'Start Date',
                   required: true,
                   formControlInstance: startDateFormControl
                  }">
            </ng-container>

            <!-- Due Date -->
            <ng-container [ngTemplateOutlet]="datePickerTemplate"
                          [ngTemplateOutletContext]="{
                   label:'Due Date',
                   required: false,
                   formControlInstance: dueDateFormControl
                   }">
            </ng-container>

          </div>

        </div>
      </div>
    </div>

    <br/>
    <mat-divider></mat-divider>
    <br/>

    <div class="clearfix overflow-x">
      <div class="md-col md-col-6">
        <ng-container [ngTemplateOutlet]="comments"></ng-container>
      </div>
      <div class="md-col md-col-6">
        <ng-container [ngTemplateOutlet]="documents"></ng-container>
      </div>
    </div>

  </div>
</form>

<mat-dialog-actions align="center" class="dialog-button-container">
  <button class="dialog-button" mat-raised-button [mat-dialog-close]="false" color="warn">Cancel</button>
  <button class="dialog-button" mat-raised-button color="primary"
          [disabled]="!formGroup.valid || narrativeFormControlValue"
          (click)="onSaveIssueTicket()">Save

    <ng-container *ngIf="narrativeFormControlValue">
      <mat-icon class="info-icon"
                matTooltip="Ensure the comment has been added using the plus (+) icon before saving">
        help_outline
      </mat-icon>
    </ng-container>
  </button>
</mat-dialog-actions>

<!-------------------------------------->
<!-- Templates-->
<!-------------------------------------->

<ng-template #inputAndDropdownFields>

  <!-- Name -->
  <mat-form-field>
    <mat-label>Name</mat-label>
    <input type="text" matInput required [formControl]="nameFormControl"
           (input)="onInputChangedUpdateIssueName($any($event).target.value)">
    <button *ngIf="nameFormControl.value" (click)="nameFormControl.reset()"
            aria-label="Clear" mat-button mat-icon-button matSuffix>
      <mat-icon style="color: grey;">clear</mat-icon>
    </button>
  </mat-form-field>

  <!--Status-->
  <ng-container [ngTemplateOutlet]="LookupValuesTemplate"
                [ngTemplateOutletContext]="{
                   label:'Status',
                   items: statusLookUpValues,
                   required: true,
                   formControlInstance: statusFormControl
                  }">
  </ng-container>

  <!--Resolution-->
  <ng-container [ngTemplateOutlet]="LookupValuesTemplate"
                [ngTemplateOutletContext]="{
                   label:'Resolution',
                   items: resolutionLookUpValues,
                   required: true,
                   formControlInstance:
                   resolutionFormControl
                  }">
  </ng-container>

  <!--Priority-->
  <ng-container [ngTemplateOutlet]="LookupValuesTemplate"
                [ngTemplateOutletContext]="{
                   label:'Priority',
                   items: priorityLookUpValues,
                   required: true,
                   formControlInstance: priorityFormControl
                  }">
  </ng-container>

  <!--Module-->
  <ng-container [ngTemplateOutlet]="LookupValuesTemplate"
                [ngTemplateOutletContext]="{
                   label:'Module',
                   items: moduleLookUpValues,
                   required: false,
                   formControlInstance: moduleFormControl
                  }">
  </ng-container>

</ng-template>


<ng-template #documents>
  <!-- Add Attachments Section -->

  <div *ngIf="fileUploadConfig['newAttachment'].uploadedFileData === null">
    <div class="flex">
      <div class="col-10">
        <h2 mat-dialog-title class="font-normal">Documents</h2>
      </div>
      <div class="col-2">
        <app-file-upload [config]="fileUploadConfig['newAttachment']"
                         [showIcon]="true"
                         [iconName]="'add'"
                         [showCustomText]="true"
                         [customText]="''"
                         (onUploadSuccess)="onFileUploadSuccess($event)">
        </app-file-upload>
      </div>
    </div>
  </div>

  <!-- Display Attachments Section-->
  <ng-container *ngIf="issueTicketAttachmentsList?.length else showEmptyDocuments">
    <ng-container *ngFor="let issueTicketAttachment of issueTicketAttachmentsList let idx=index">
      <div class="flex justify-between items-baseline mb1">
        <div class="flex-auto pr1 break-word overflow-hidden">
          <ng-container *ngIf="fileUploadConfig['file'+idx]?.uploadedFileData?.file else noFileChoose">
            <a href target="#"
               (click)="onDownloadFile($event, 'file'+idx)">
              <span [matTooltip]="getFileName(idx)" matTooltipPosition="above">
                {{getFileName(idx) |  truncateText: {sliceEnd: 30, append: '...'} }}
              </span>
            </a>
          </ng-container>
          <ng-template #noFileChoose>
            No File Chosen
          </ng-template>
        </div>
        <div class="col-4">
          <ng-container
            *ngIf="fileUploadConfig['file' + idx]?.uploadedFileData?.created else fileUpdatedAt">
            {{fileUploadConfig['file' + idx]?.uploadedFileData?.created | date: dateFormat}}
          </ng-container>
          <ng-template #fileUpdatedAt>
            {{fileUploadConfig['file' + idx]?.uploadedFileData?.updated | date: dateFormat}}
          </ng-template>
        </div>
        <div class="col-2">
          <mat-icon class="mat-primary-color hand-cursor" matTooltip="DELETE"
                    (click)="onDeleteIssueTicketAttachment($event, issueTicketAttachment)">
            delete
          </mat-icon>
        </div>
      </div>
    </ng-container>
  </ng-container>
</ng-template>

<!-- Empty Placeholder Section-->
<ng-template #showEmptyDocuments>
  <div class="center">
    <label class="mat-primary-color">No attachments exist</label>
  </div>
</ng-template>


<ng-template #comments>
  <h2 mat-dialog-title class="font-normal">Notes</h2>

  <!--Add Comments Section-->
  <form id="comment-form" [formGroup]="addCommentsFormGroup">
    <mat-form-field>
      <mat-label>Add new note</mat-label>
      <div class="new-comment">
        <input [formControlName]="controls.Narrative" type="text" matInput
        (blur)="onBlurComment()">
        <mat-icon class="hand-cursor" matTooltip="attachment" (click)="onAddNewComment()">
          add
        </mat-icon>
      </div>
    </mat-form-field>
  </form>

  <!-- Display Comments Section-->
  <ng-container *ngIf="issueTicketDetailsList?.length else showEmptyComments">
    <ng-container *ngFor="let issueTicketDetails of issueTicketDetailsList">
      <div class="clearfix">
        <div class="col sm-col-12 md-col-3">
          {{issueTicketDetails?.createdBy}}
        </div>

        <div class="col sm-col-12 md-col-3">
          {{issueTicketDetails?.issueTicketDetail?.narrativeDate | date: dateFormat}}
        </div>

        <div class="col sm-col-12 md-col-5 scroll-y">
          {{issueTicketDetails?.issueTicketDetail?.narrative}}
        </div>

        <div class="col sm-col-12 md-col-1">
          <mat-icon class="mat-primary-color hand-cursor" matTooltip="DELETE"
                    (click)="onDeleteIssueTicketComment($event, issueTicketDetails)">
            delete
          </mat-icon>
        </div>
      </div>
      <br/>
    </ng-container>
  </ng-container>

  <!-- Empty Placeholder Section-->
  <ng-template #showEmptyComments>
    <div class="center">
      <label class="mat-primary-color">No notes exist</label>
    </div>
  </ng-template>
</ng-template>

<!---------------------------->
<!--Lookup Values Template--->
<!---------------------------->
<ng-template #LookupValuesTemplate
             let-label="label"
             let-items="items"
             let-required="required"
             let-formControlInstance="formControlInstance">
  <!--  required context variable is just added for module as this is not required-->

  <ng-container *ngIf="label==='Resolution' else defaultTemplate">
    <mat-form-field>
      <mat-label>{{label}}</mat-label>

      <!---------------------------->
      <!--ONLY DIFFERENCE COMPARE TO "defaultTemplate" IS MAKE RESOLUTION REQUIRED IF STATUS IS CLOSED-->
      <!---------------------------->

      <mat-select [formControl]="formControlInstance"
                  [required]="isResolutionRequired"
                  (selectionChange)="onSelectionChanged($event.source.value, label)">
        <mat-option *ngFor="let item of items" [value]="item.name">
          {{item.name}}
        </mat-option>
      </mat-select>

      <button *ngIf="formControlInstance.value" (click)="formControlInstance.reset()"
              aria-label="Clear" mat-button mat-icon-button matSuffix>
        <mat-icon style="color: grey;">clear</mat-icon>
      </button>
    </mat-form-field>
  </ng-container>

  <ng-template #defaultTemplate>
    <mat-form-field>
      <mat-label>{{label}}</mat-label>
      <mat-select [formControl]="formControlInstance"
                  [required]="required"
                  (selectionChange)="onSelectionChanged($event.source.value, label)">
        <mat-option *ngFor="let item of items" [value]="item.name">
          {{item.name}}
        </mat-option>
      </mat-select>

      <button *ngIf="formControlInstance.value" (click)="formControlInstance.reset()"
              aria-label="Clear" mat-button mat-icon-button matSuffix>
        <mat-icon style="color: grey;">clear</mat-icon>
      </button>
    </mat-form-field>
  </ng-template>
</ng-template>

<!---------------------------->
<!--DatePicker Template--->
<!---------------------------->
<ng-template #datePickerTemplate
             let-label="label"
             let-required="required"
             let-formControlInstance="formControlInstance">

  <mat-form-field>
    <mat-label>{{label}}</mat-label>
    <input [formControl]="formControlInstance" matInput
           [required]="required"
           [matDatepicker]="selectDate">
    <mat-datepicker-toggle [for]="selectDate" matIconSuffix></mat-datepicker-toggle>
    <mat-datepicker-toggle matIconSuffix (click)="formControlInstance.reset()">
      <mat-icon matDatepickerToggleIcon>clear</mat-icon>
    </mat-datepicker-toggle>
    <mat-datepicker #selectDate></mat-datepicker>
  </mat-form-field>
</ng-template>

